var brand = {

  init : function () {

      $('.c-horizontal-nav ul li a').on('click',function(e){
        e.preventDefault();
        var target = $(this).data('target');
        var index = $('.c-horizontal-nav ul li').index($(this).parent());
        switchBrand(target, index);
      });
      $('.c-horizontal-nav select').on('change',function(e){
        e.preventDefault();
        var target = $(this).val();
        var index = $('.c-horizontal-nav select option').index($('.c-horizontal-nav select option[value="'+target+'"]'));
        switchBrand(target, index);
      });
      function switchBrand(target, index){
        $('.c-horizontal-nav ul li').eq(index).addClass('active').siblings().removeClass('active');
        $('.c-horizontal-nav select').val(target);
        $('.l-brand-list-section__list li.'+target).delay(200).fadeIn(200);
        $('.l-brand-list-section__list li:not(.'+target+')').fadeOut(200);
      }
  }

}

if($('#p-brand')[0]){
    brand.init();
}
